import { render, staticRenderFns } from "./ImageResultCard.vue?vue&type=template&id=83e6a092&"
import script from "./ImageResultCard.vue?vue&type=script&lang=ts&"
export * from "./ImageResultCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports